import { render, staticRenderFns } from "./TelaAvisoEmail.vue?vue&type=template&id=5f3fd901&scoped=true&"
import script from "./TelaAvisoEmail.vue?vue&type=script&lang=js&"
export * from "./TelaAvisoEmail.vue?vue&type=script&lang=js&"
import style0 from "./TelaAvisoEmail.vue?vue&type=style&index=0&id=5f3fd901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3fd901",
  null
  
)

export default component.exports